module.exports = __webpack_public_path__ + "static/img/5.0787a1b9.jpg";